export enum SetSockMessagesType {
  SET_SOCKMESSAGES = "SET_SOCKMESSAGES",
}
